import React from 'react';
import { Type } from '../Type/Type';
import style from './ProgressBar.module.less';
export var ProgressBar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      label = _ref.label,
      value = _ref.value,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'step' : _ref$variant,
      _ref$separator = _ref.separator,
      separator = _ref$separator === void 0 ? ' of ' : _ref$separator,
      _ref$stepLabel = _ref.stepLabel,
      stepLabel = _ref$stepLabel === void 0 ? 'Step' : _ref$stepLabel;
  var isPercentage = variant === 'percentage';
  var lowestValue = isPercentage ? 0 : 1;
  var progressValue = Math.max(lowestValue, value);
  var percentageComplete = Math.max(0, Math.min(100 * progressValue / max, 100));
  var progressInformation = isPercentage ? "".concat(Math.round(percentageComplete), "% completed") : "".concat(stepLabel, " ").concat(Math.min(progressValue, max)).concat(separator).concat(max);
  var progressLabel = isPercentage ? "".concat(label, " \u2022 ").concat(progressInformation) : "".concat(progressInformation, ": ").concat(label);
  var progressTitle = label ? progressLabel : progressInformation;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: className
  }, /*#__PURE__*/React.createElement(Type, {
    "aria-live": "polite",
    "aria-valuenow": percentageComplete,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-label": progressTitle,
    className: style.progressTitle,
    color: "neutral-darker",
    role: "progressbar",
    size: 1
  }, progressTitle), /*#__PURE__*/React.createElement("div", {
    className: style.progressBar,
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: style.progressBarBackground
  }, /*#__PURE__*/React.createElement("div", {
    className: style.progressBarValue,
    style: {
      width: "".concat(percentageComplete, "%")
    },
    "data-value": percentageComplete
  }))));
});
ProgressBar.displayName = 'ProgressBar';